﻿import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from '../_models/user';
import { Router } from '@angular/router';
import { HttpService } from './http.service';

import * as jwt_decode from 'jwt-decode';
import { Province, Amphoe, Tambon, DefConfig, TitleCode } from '../_models/province';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {

    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    provinces: Province[];
    amphoes: Amphoe[];
    tambons: Tambon[];
    defConfig: DefConfig;
    title_code: TitleCode;
    a_numload = 0;
    p_numload = 0;
    err: any;

    constructor(
        private router: Router,
        private http: HttpService,

    ) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    public getCurrentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(username: string, password: string) {
        return this.http.requestPost('auth/login', { username, password})
            .pipe(
                map(res => {
                    if(res.status ==200){
                        let user = res.value;
                        if (user && user.token) {
                          localStorage.setItem(
                            "currentUser",
                            JSON.stringify(user)
                          );
                          this.currentUserSubject.next(user);
                          localStorage.setItem(
                            "province",
                            JSON.stringify(res.province)
                          );
                          localStorage.setItem(
                            "amphoe",
                            JSON.stringify(res.amphoe)
                          );
                          localStorage.setItem(
                            "tambon",
                            JSON.stringify(res.tambon)
                          );
                          localStorage.setItem(
                            "title_code",
                            JSON.stringify(res.prefix)
                          );
                          localStorage.setItem(
                            "defConfig",
                            JSON.stringify(res.defConfig)
                          );
                          localStorage.setItem(
                            "b_config",
                            JSON.stringify(res.building_config)
                          );
                        }
                        return res;
                    }else{
                        return res;
                    }
                    
                })
            );
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
        this.router.navigate(['/login']);
        window.location.reload();
    }

    getToken(): string {
        let u: User;
        u = JSON.parse(localStorage.getItem('currentUser'));
        return u.token;
    }

    getTokenExpirationDate(token: string): Date {
        const decoded = jwt_decode(token);
        if (decoded.exp === undefined) { return null; }
        const date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        return date;
    }

    isTokenExpired(token?: string): boolean {
        if (!token) { token = this.getToken(); }
        if (!token) { return true; }
        const date = this.getTokenExpirationDate(token);
        if (date === undefined) { return false; }
        return !(date.valueOf() > new Date().valueOf());
    }


    loadDefault(){
        this.http.requestGet('getConfig').subscribe((data) => {
            this.defConfig = data;
            localStorage.setItem('defConfig', JSON.stringify(this.defConfig));
        });
    }

    isAdmin(): boolean {
        if ( this.currentUserValue.role == 100){
            return true;
        }
    }

}
